import styled from 'styled-components';

export const ChartWrapper = styled.div`
  position: relative;
`;

const Wrapper = styled.div`
  padding-top: 5px;
`;

export default Wrapper;
